export const variationAExcludedFields = {
  step1: ['FirstName', 'LastName', 'NumberOfEmployees'],
  step2: ['Email'],
}

export const variationBExcludedFields = {
  step1: ['FirstName', 'LastName', 'Email'],
  step2: ['NumberOfEmployees'],
}

// No excluded fields. Useful to complete submissions for every step
// and test the full cycle (submit, get lead data and store is in session,
// then submit data to the same lead)
export const variationTestExcludedFields = {
  step1: [] as string[],
  step2: [] as string[],
}
